import posthog from 'posthog-js';

/**
 * Identify the current user in PostHog, linking the frontend anonymous
 * session to the backend person record (same distinct_id = typed user UUID).
 * Call this immediately after a successful login or registration response.
 */
export function identifyPostHogUser(
  userId: string,
  accountType: string,
  email?: string
): void {
  try {
    if (!userId) return;
    const properties: Record<string, string> = {
      account_type: accountType,
    };
    if (email) {
      properties.email = email;
    }
    posthog.identify(userId, properties);
  } catch (e) {
    console.error('PostHog identify failed:', e);
  }
}

/**
 * Reset the PostHog session on logout so the next user on the same
 * browser starts a fresh anonymous session unlinked from this person.
 */
export function resetPostHogUser(): void {
  try {
    posthog.reset();
  } catch (e) {
    console.error('PostHog reset failed:', e);
  }
}
